import { render, staticRenderFns } from "./ItemTable.row.vue?vue&type=template&id=113980a0&"
import script from "./ItemTable.row.vue?vue&type=script&lang=js&"
export * from "./ItemTable.row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports